import { render } from "./TyreDetail.vue?vue&type=template&id=b9e36d64"
import script from "./TyreDetail.vue?vue&type=script&lang=js"
export * from "./TyreDetail.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__